import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { questions } from '../../data/questions';
import { QuestionCard } from './QuestionCard';
interface QuizScreenProps {
  answers: (boolean | null)[];
  setAnswers: React.Dispatch<React.SetStateAction<(boolean | null)[]>>;
  onComplete: () => void;
}
export function QuizScreen({
  answers,
  setAnswers,
  onComplete
}: QuizScreenProps) {
  const answeredCount = answers.filter(a => a !== null).length;
  const progressPercentage = answeredCount / questions.length * 100;
  const displayCount = Math.min(answeredCount + 1, questions.length);
  useEffect(() => {
    if (answeredCount === questions.length) {
      const timer = setTimeout(() => {
        onComplete();
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [answeredCount, onComplete]);
  const handleAnswer = (index: number, value: boolean) => {
    setAnswers(prev => {
      const newAnswers = [...prev];
      newAnswers[index] = value;
      return newAnswers;
    });
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="py-8 px-5 min-h-screen" data-id="element-54">
      <div className="max-w-[680px] mx-auto" data-id="element-55">
        {/* Sticky Progress Bar */}
        <div className="sticky top-0 z-10 bg-[var(--black)] pt-2 pb-4" data-id="element-56">
          <div className="w-full h-1 bg-[#1a1a1a] rounded-sm mb-4 overflow-hidden" data-id="element-57">
            <motion.div className="h-full bg-[var(--gold)] rounded-sm" initial={{
            width: 0
          }} animate={{
            width: `${progressPercentage}%`
          }} transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }} data-id="element-58" />
          </div>
          <div className="text-center text-[var(--gray)] text-xs tracking-[2px] font-semibold" data-id="element-59">
            PREGUNTA {displayCount} DE 10
          </div>
        </div>

        {/* Questions List */}
        <div className="mt-6" data-id="element-60">
          {questions.map((q, i) => <QuestionCard key={i} question={q} index={i} answer={answers[i]} onAnswer={handleAnswer} data-id="element-61" />)}
        </div>
      </div>
    </motion.div>;
}